/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

function RegrasPromoSJ() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container spacing={2} sx={{ mx: "auto", mt: 3 }}>
          <Grid item xs={12} sm={6} md={4}>
            <DefaultCounterCard
              count={29}
              suffix="/06/2024"
              title="Campanha válida"
              description="*Campanha válida até 29 de junho de 2024."
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <DefaultCounterCard
              prefix="R$ 39,9"
              count={9}
              suffix=""
              title="Valor após 3 meses"
              description="*Após 03 meses o valor será de R$ 79,99."
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <DefaultCounterCard
              count={1}
              suffix="ª Mensalidade"
              title="Primeira mensalidade"
              description="*O pagamento da primeira mensalidade será em agosto."
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default RegrasPromoSJ;
